export default __webpack_public_path__ + "static/media/24.ee4dff7e.png";